class UploadFile {
    constructor(tipoLead, 
                file){
        this.tipoLead = tipoLead,
        this.file = file
    }
}


export {
    UploadFile
}